import noop from 'lodash/noop';
import { put } from 'redux-saga/effects';

import * as Constants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';

export function* appStoreClicked() {
  const logEvent = getInDomain('analytics.actions.logEvent', noop);
  yield put(
    logEvent({
      eventType: Constants.Analytics.EventTypes.CLICK,
      eventName: Constants.Analytics.EventNames.CLICKED_APP_STORE_LINK,
    }),
  );
}
